module.exports = __webpack_public_path__ + "img/imdb-color.e022bd66.svg";